<template>
  <div class="link-account-confirmation">
    <div v-if="isLoading" class="link-account-confirmation__loading">
      <font-awesome-icon icon="spinner" size="3x" spin />
    </div>
    <div v-else class="link-account-confirmation__status">
      <p class="link-account-confirmation__message">{{ message || error }}</p>
    </div>
  </div>
</template>

<script>
import {
  ref, onMounted, onUnmounted, computed,
} from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

export default {
  name: 'LinkAccountConfirmation',
  setup() {
    const isLoading = ref(true);
    const error = ref('');
    const { key = null, emails = null } = useRoute().query;
    const store = useStore();

    let timeoutId;
    onMounted(async () => {
      timeoutId = setTimeout(() => {
        isLoading.value = false;
        error.value = 'Error linking account. Please try again.';
      }, 8000);

      await store.dispatch('validateAndLinkAccount', { emails, key });
      clearTimeout(timeoutId);
      isLoading.value = false;
    });

    onUnmounted(() => {
      clearTimeout(timeoutId);
    });

    return {
      isLoading,
      message: computed(() => store.state.linkingEmailResponse),
      error,
    };
  },
};
</script>

<style lang="scss" scoped>
.link-account-confirmation {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 12rem;

  &__loading {
    svg {
      color: $color-dark-gray;
    }
  }

  &__message {
    font-size: 1.125rem;
    text-align: center;
    margin: 0;
  }
}
</style>
